// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { useContext, useEffect, useRef } from "react";
import { store } from "../../Helper/Context/Store";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Autoplay, Pagination } from "swiper/modules";
import "./BestSellerSection.css";
import ProductCard from "../ProductCard/ProductCard";
import ProductCard1 from "../ProductCard/ProductCard1";
import { Skeleton } from "antd";
import TopIcon from "../../assets/img/eliments/leaf-1.png";
import BottomIcon from "../../assets/img/eliments/leaf-2.png";
// import TopIcon from "../../assets/img/eliments/rakhi-left.webp";
// import BottomIcon from "../../assets/img/eliments/rakhi-right.webp";
export default function BestSellerSection({ itemsData, heading1, heading2 }) {
  const { cartItems } = useContext(store);

  const swiperRef = useRef(null);

  useEffect(() => {
    if (swiperRef.current && itemsData?.length > 0) {
      swiperRef.current.swiper.update();
      swiperRef.current.swiper.autoplay.start();
    }
  }, [itemsData]);

  return (
    <div>
      <section className="my-5 section-spacing-x best-seller-section">
        {/* <img src={TopIcon} className="img-fluid top-left-icon" />
        <img src={BottomIcon} className="img-fluid bottom-right-icon" /> */}
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 text-center  main-heading-box">
              <h2 className="main-heading ">{heading1}</h2>
              <p
                style={{
                  maxWidth: "640px",
                  margin: "0 auto",
                }}>
              Make every celebration meaningful with beautiful gifts and carefully curated hampers filled with festive charm. </p>

              <div className="view-all-btn">
                <a
                  href="/category/occasion/diwali-8th-nov"
                  className="theme-btn">
                  View All
                </a>
              </div>
            </div>
            <div className="col-12">
              <Swiper
                key={itemsData?.length}
                ref={swiperRef}
                pagination={{
                  clickable: true,
                  dynamicBullets: true,
                }}
                modules={[Autoplay, Pagination]}
                slidesPerView={2}
                spaceBetween={20}
                loop={true}
                slidesPerGroup={2}
                speed={800}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                breakpoints={{
                  640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    slidesPerGroup: 2,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  1024: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                    slidesPerGroup: 4,
                  },
                }}
                className="mySwiper pb-4 pb-lg-5 swiper-slide-height">
                {itemsData.length > 0 ? (
                  itemsData?.map((data, index) => {
                    const isInCart = cartItems.find((item) => {
                      if (item.fld_variantid === data.fld_variantid) {
                        return item;
                      }
                    });
                    return (
                      <SwiperSlide
                        key={`exclusive-${index}`}
                        className="exclusive-offers-card mb-4 mb-lg-0">
                        <ProductCard1 productData={data} isInCart={isInCart} />
                      </SwiperSlide>
                    );
                  })
                ) : (
                  <div className="col-12">
                    <div className="row">
                      <div className={`col-md-6 col-lg-3 col-6 mb-4 mb-lg-0`}>
                        <div className="product-img-skeleton">
                          <Skeleton.Image className="h-100 w-100" />
                          <div className="buttons flex-column detailsbtn mb-0">
                            <h2 className="prod-price">
                              <Skeleton.Button />
                            </h2>
                          </div>
                          <div className="mt-3">
                            <Skeleton.Input />
                          </div>
                        </div>
                      </div>
                      <div className={`col-md-6 col-lg-3 col-6 mb-4 mb-lg-0`}>
                        <div className="product-img-skeleton">
                          <Skeleton.Image className="h-100 w-100" />
                          <div className="buttons flex-column detailsbtn mb-0">
                            <h2 className="prod-price">
                              <Skeleton.Button />
                            </h2>
                          </div>
                          <div className="mt-3">
                            <Skeleton.Input />
                          </div>
                        </div>
                      </div>
                      <div className={`col-md-6 col-lg-3 col-6 mb-4 mb-lg-0`}>
                        <div className="product-img-skeleton">
                          <Skeleton.Image className="h-100 w-100" />
                          <div className="buttons flex-column detailsbtn mb-0">
                            <h2 className="prod-price">
                              <Skeleton.Button />
                            </h2>
                          </div>
                          <div className="mt-3">
                            <Skeleton.Input />
                          </div>
                        </div>
                      </div>
                      <div className={`col-md-6 col-lg-3 col-6 mb-4 mb-lg-0`}>
                        <div className="product-img-skeleton">
                          <Skeleton.Image className="h-100 w-100" />
                          <div className="buttons flex-column detailsbtn mb-0">
                            <h2 className="prod-price">
                              <Skeleton.Button />
                            </h2>
                          </div>
                          <div className="mt-3">
                            <Skeleton.Input />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
